<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.student.supplementScorePop') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mt-6">
                        <v-col cols="12">
                            <v-select
                                :items="classItems"
                                :rules="[rules.required]"
                                :label="$vuetify.lang.t('$vuetify.custom.student.choiceClass')"
                                hide-details
                                solo
                                v-model="formData.classId"
                                @change="initExamSelect"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :rules="[rules.required]"
                                :items="examTypeItems"
                                :label="$vuetify.lang.t('$vuetify.custom.student.choiceExam')"
                                hide-details
                                solo
                                v-model="formData.examId"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :rules=scoreRules
                                :label="$vuetify.lang.t('$vuetify.custom.student.score')+'*'"
                                v-model="formData.score"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}
                </v-btn>
                <v-btn color="success" dark @click="addUser">{{ $vuetify.lang.t('$vuetify.custom.okBtn') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>

    export default {
        name: 'score-supplement',
        model: {
            prop: 'suppDialog',
            event: 'parent-event'
        },
        props: {
            suppDialog: Boolean,
            stuId: String
        },
        mounted() {
            this.initSelect()
        },
        watch:{
            suppDialog(){
                if(this.suppDialog){
                    this.initSelect()
                    this.examTypeItems = []
                }
            }
        },
        data: () => ({
            formData:{
                studentId:'',
                classId:'',
                examId:'',
                score:null,
            },
            classItems: [
            ],
            examTypeItems: [
            ],
            rules: {
                required: value => !!value || '请输入'
            },
            scoreRules: [
                v => !!v || '必填',
                v => /^([0-9]\d?|100)$/.test(v) || '0-100之内',
            ],
        }),
        methods: {
            initExamSelect(){
                this.examTypeItems = []
                this.formData.examId = ''
                this.$api.exam.selectExamByClassId({id:this.formData.classId}).then(data => {
                    if (data.data) {
                        data.data.forEach((obj, index) => {
                            this.examTypeItems.push({text: obj.examName, value: obj.id})
                        })
                    }
                })
            },
            initSelect() {
                this.classItems = []
                this.$api.classList.getLatelyClass().then(data => {
                    if (data.data) {
                        data.data.forEach((obj, index) => {
                            this.classItems.push({text: obj.className, value: obj.id})
                        })
                    }
                })
            },
            hiddenDialog() {
                this.$refs.form.reset()
                this.$emit('parent-event', false);
            },
            addUser() {
                if (this.$refs.form.validate()) {
                    this.formData.studentId = this.stuId
                    this.$api.achievement.insertAchievement(this.formData).then(data => {
                        if (data.flag) {
                            this.$dialog.alert("补录成功");
                            this.hiddenDialog();
                        } else {
                            this.$dialog.alert(data.msg)
                        }
                    })

                }
            }
        },
        components: {},
    }
</script>
